import React from "react";
import { TouchableOpacity } from "react-native";

import ImageComponent from "../../ImageComponent";

export default function MariPartyIcon({ onPress = () => {} }) {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={{
        width: 66,
        paddingRight: 3,
      }}
    >
      <ImageComponent
        image={require("../../../../../assets/MariParty.png")}
        style={{ width: "100%", height: 98 }}
      />
    </TouchableOpacity>
  );
}
